import {createTheme} from '@mui/material/styles';
import {createOverrides} from './overrides';
import {createPalette} from './palette';
import {tokens} from './tokens';
import {typography} from './typography';

export type ArkThemeOptions = {
  mode?: 'light' | 'dark';
  accent?: string;
};

export const createArkTheme = (options: ArkThemeOptions = {}) => {
  const {mode = 'light', accent} = options;

  const baseTheme = createTheme({
    palette: createPalette(mode, accent),
    typography,
    breakpoints: {},
    tokens,
  });

  return createTheme(baseTheme, {
    components: createOverrides(baseTheme),
  });
};
